export class CountryDTO{
    id!: number;
    name?: string;
    //regionName?: string;
    regionId!: number;
    isActive?: boolean;
    countrycode!:string;
}